import StarterKit from '@tiptap/starter-kit';
import TextAlign from '@tiptap/extension-text-align';
import { ScriptRow } from './ScriptRow';
import { ScriptCell } from './ScriptCell';
import { RefImage } from './RefImage';
import { ScriptHeaderRow } from './ScriptHeaderRow';
import { BriefField } from './BriefField';
import { CommentDecorations } from './CommentDecorations';
import { ListTabKeymap } from './ListTabKeymap';
import { ReadThroughHighlight } from './ReadThroughHighlight';

// One source of truth for both lists below: the only difference between the
// admin's editor and the client's is whether a `briefField` node view builds
// its authoring chrome, so the schema, the guard and every other extension are
// shared by construction and cannot drift.
function buildExtensions(briefControls: boolean) {
  return [
    StarterKit.configure({
      heading: { levels: [1, 2, 3] },
      // Disable codeBlock to keep scripts plain prose; can re-enable later if needed.
      codeBlock: false,
      horizontalRule: false,
    }),
    TextAlign.configure({
      types: ['heading', 'paragraph'],
      alignments: ['left', 'center', 'right'],
      defaultAlignment: 'left',
    }),
    ScriptHeaderRow,
    ScriptRow,
    ScriptCell,
    // Reference images (2B). Henry's editor gets the caption field and tools;
    // every client editor renders them read-only.
    RefImage.configure({ authoring: briefControls }),
    // Interview-brief field container. Registered after ScriptCell because its
    // content spec names scriptHeaderRow/scriptRow (a `rows` field holds the
    // Audio/Visual table). Inert on ordinary scripts: no briefField nodes, no
    // node views, and its guard plugin returns early.
    BriefField.configure({ controls: briefControls }),
    CommentDecorations,
    // Tab/Shift+Tab inside list items always indents/outdents and never lets
    // focus escape to surrounding buttons. See ListTabKeymap.ts for context.
    ListTabKeymap,
    // Read-through (2B): row and phrase highlight, inert until played.
    ReadThroughHighlight,
  ];
}

export const editorExtensions = buildExtensions(true);

/**
 * The client review page's list. Identical but for the brief field's audience
 * chip and ⋯ menu, which a client must never see: they flip audience, hide,
 * rename, delete and reorder fields, and the server rehydrates every field's
 * attrs from the master doc, so on a client's suggestion they would do
 * nothing. The read-only view drops them anyway (nothing is editable there);
 * this is what drops them from suggest mode, where the body IS editable.
 */
export const clientEditorExtensions = buildExtensions(false);
